import React from 'react';

import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';

import ActionButton from 'components/buttons/ActionButton';
import ActionLink from 'components/buttons/ActionLink';

export default function ProjectContentReviewFooter({
  anyUnsaved,
  contentReviewSubmitting,
  isReviewing,
  projectId,
  submitProjectContentReview,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <>
      <PortaledActionButtons direction='left'>
        <ActionLink
          disableAfterClick={true}
          linkText={i18nTShared('previous')}
          performCheck={anyUnsaved}
          styleClasses='tw-apply-outlined-button tw-apply-outlined-button--md tw-apply-outlined-button--blue-grey tw-apply-outlined-button--on-dark'
          url={`/projects/${projectId}/method${isReviewing ? '?review=true' : ''}`}
        />
      </PortaledActionButtons>
      <PortaledActionButtons direction='right'>
        <ActionButton
          buttonText={i18nTShared('finish')}
          isDisabled={contentReviewSubmitting}
          onClick={submitProjectContentReview}
          styleClasses='tw-apply-filled-button tw-apply-filled-button--md tw-apply-filled-button--mint tw-apply-filled-button--on-dark'
        />
      </PortaledActionButtons>
    </>
  );
}

ProjectContentReviewFooter.propTypes = {
  anyUnsaved: PropTypes.bool,
  contentReviewSubmitting: PropTypes.bool,
  isReviewing: PropTypes.bool,
  projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  submitProjectContentReview: PropTypes.func,
};

const PortaledActionButtons = ({ children, direction }) => {
  const buttonLocation = document.getElementsByClassName(
    `project-actions-${direction}`,
  );

  return ReactDOM.createPortal(children, buttonLocation[0]);
};
